import React, { useEffect, useState } from 'react'
import { AlertCard, ScreenContainer } from './styles/mobile-styles'
import trophyIcon from 'src/images/game/trophy.png'
import GameBtn from './GameBtn'
import { useQuery } from 'react-query'
import { getResult } from 'src/apis/gameApi'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'

export default function GameCompletedPage() {
  const history = useHistory()
  const [isVisible, setIsVisible] = useState<boolean>(false)

  const { data: resultData } = useQuery({
    queryKey: ['fetchResult', 'question', 12],
    queryFn: async () => {
      return await getResult(12)
    },
  })

  // Fade in animation when component mounts
  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsVisible(true)
    }, 100) // Small delay for smooth appearance

    return () => clearTimeout(timeout)
  }, [])

  const handleCheckLeaderboard = () => {
    history.push('/leaderboard')
  }

  const handleReturnLobby = () => {
    history.push('/lobby')
  }

  return (
    <>
      <ScreenContainer isVisible={isVisible}>
        <AlertCard style={{ alignSelf: 'center' }}>
          <legend>
            <div>Score</div>
          </legend>
          <div className="d-flex flex-column justify-content-center align-items-center gap-3 flex-wrap winner">
            <img src={trophyIcon} alt="trophy" style={{ width: '145px', height: '145px' }} />
            <h4>Congratulations!</h4>
            <p>See your ranking now on the leaderboard!</p>

            <h2 className="score">{`${resultData?.totalScore}`}</h2>
          </div>
        </AlertCard>
        <GameBtn arrow onClick={handleCheckLeaderboard}>
          Check Leaderboard
        </GameBtn>
        <GameBtn arrow onClick={handleReturnLobby}>
          Return to Lobby
        </GameBtn>
      </ScreenContainer>
    </>
  )
}
